import React, { useState, useEffect } from 'react';
import ReactQuill from "react-quill";
import 'quill/dist/quill.snow.css';
import { useTranslation } from 'react-i18next';
import Button from '../../CommonFields/Button';
import { useNavigate } from 'react-router';
import { routesFrontend } from '../../RouterFiles/routes';
import { scrimGameRules, scrimGameCreate, scrimGameEdit, rulesByScrimId } from "../../../api/scrim.api";
import { toastError } from '../../../Utilities/toast';

const CreateScrimRules = ({ id, setRules, scrimData }) => {
  const [value, setRulesData] = useState('');
  const { t } = useTranslation();
  const navigate = useNavigate();

  var modules = {
    toolbar: [
      [{ size: ["small", false, "large", "huge"] }],
      ["bold", "italic", "underline", "strike", "blockquote"],
      [{ list: "ordered" }, { list: "bullet" }],
      ["link", "image"],
      [
        { list: "ordered" },
        { list: "bullet" },
        { indent: "-1" },
        { indent: "+1" },
        { align: [] }
      ],
      [{ "color": ["#000000", "#e60000", "#ff9900", "#ffff00", "#008a00", "#0066cc", "#9933ff", "#ffffff", "#facccc", "#ffebcc", "#ffffcc", "#cce8cc", "#cce0f5", "#ebd6ff", "#bbbbbb", "#f06666", "#ffc266", "#ffff66", "#66b966", "#66a3e0", "#c285ff", "#888888", "#a10000", "#b26b00", "#b2b200", "#006100", "#0047b2", "#6b24b2", "#444444", "#5c0000", "#663d00", "#666600", "#003700", "#002966", "#3d1466", 'custom-color'] }],
    ]
  };

  var formats = [
    "header", "height", "bold", "italic",
    "underline", "strike", "blockquote",
    "list", "color", "bullet", "indent",
    "link", "image", "align", "size",
  ];

  const handleProcedureContentChange = (content) => {
    setRulesData(content);
  };






  useEffect(() => {
    console.log(scrimData);

    if (scrimData?.rules) {
      setRulesData(scrimData.rules);
      // setRules(scrimData.rules);
    } else {
      const fetchGameRules = async () => {
        try {
          const gameId = localStorage.getItem("activeGameId");
          const data = {
            filter: {
              game: `${gameId}`
            }
          };

          const response = id ? await rulesByScrimId(id) : await scrimGameRules(data);
          if (id) {
            if (response?.rules) {
              setRulesData(response?.rules)
            } else {
              setRulesData(localStorage.getItem("rules"));
            }
          } else {
            const rules = response.data;

            const rulesData = localStorage.getItem("rules");
            if (rulesData) {
              setRulesData(rulesData)
            } else {
              setRulesData(rules.rules);
            }
          }

          // setRules(rules.rules); 
        } catch (error) {
          console.error('API Error:', error);
        }
      };

      fetchGameRules();
    }
  }, [setRules, scrimData]);

  const handleAddData = async () => {

    // try {
    const updatedScrimData = { ...scrimData, rules: value };
    localStorage.setItem("rules", updatedScrimData.rules)
    if (id) {
      try {
        if (updatedScrimData) {
          updatedScrimData._id = id;

          const response = await scrimGameEdit(updatedScrimData); // Call the API here

          if (response.success) {
            localStorage.setItem("toastMessage", "Scrim updated successfully");
            localStorage.removeItem("scrimDetails");
            localStorage.removeItem("selectedGameType")
            localStorage.removeItem("rules");
            navigate("/" + routesFrontend.privateScrim + '/' + routesFrontend.privateScrimList);
          } else {
            console.log("createscrimissue", response)
            toastError(response.data.errors[0].msg)
          }
        }
      } catch (error) {
        console.error("API call failed:", error);
      }
      return;
    }
    // var response = await scrimGameCreate(updatedScrimData);
    // if (response.success === true) {
    navigate("/" + routesFrontend.privateScrim + '/' + routesFrontend.privateScrimSummary, { state: updatedScrimData });
    // }
    // } catch (error) {
    //   console.error("API call failed:", error);
    // }
  };

  return (
    <div className='scrim-rules mt-4'>
      <ReactQuill
       className="custom-quill-editor"
        theme="snow"
        modules={modules}
        formats={formats}
        placeholder={t('private_contest.write_content') }
        value={value}
        onChange={handleProcedureContentChange}
        style={{ height: "60vh" }}
        readOnly={false}
      />
      <p className='mt-4'>
        *note:{t("private_contest.notes_msg_create_contest")}
      </p>
      <div>
        <Button text={id ? t("private_contest.submit_scrim") : t("private_contest.next")} onClick={handleAddData} />
      </div>
    </div>
  );
};

export default CreateScrimRules;
